<div class="vertical-filters" [ngClass]="{ collapsed: !isFiltersMenuOpen() }">
  <div class="vertical-filters-header">
    <div class="header__left-side">
      <img src="assets/images/common/filter.svg" (click)="onToggleClick()" alt="filter" />
      <div>Filters</div>
    </div>
    <img
      src="assets/images/arrows/chevron.svg"
      class="vertical-filters-header-img"
      (click)="onToggleClick()"
      alt="toggle"
    />
  </div>
  <div class="vertical-filters-content">
    @for (optionGroup of options(); track optionGroup.group) {
      <app-accordion
        [inMultiSelect]="true"
        [expanded]="expandedGroups().has(optionGroup.group.displayName ?? '')"
        [accordionTitle]="optionGroup.group.displayName | beautifyDisplayString"
        (accordionExpansionEvent)="expandClicked(optionGroup.group, $event)"
      >
        @for (option of optionGroup.group.options; track $index) {
          <div
            class="vertical-filters-option"
            [ngClass]="{
              selected: selectedIds.has(option.id) && !option.disabled,
              disabled: option.disabled,
            }"
            (click)="onSelect(option.id, optionGroup.filter)"
          >
            <mat-checkbox
              color="primary"
              [checked]="selectedIds.has(option.id)"
              (click)="$event.stopPropagation()"
              (change)="onSelect(option.id, optionGroup.filter)"
            />
            <img *ngIf="option.iconPath" [src]="option.iconPath" class="option-img" />
            <div class="vertical-filters-option-text" appLongTextTooltip>
              {{
                option.withoutBeautifyDisplayName ? option.displayName : (option.displayName | beautifyDisplayString)
              }}
            </div>
          </div>
        }
      </app-accordion>
    }
  </div>
</div>
<div [ngClass]="{ collapsed: isFiltersMenuOpen() }">
  <img
    src="assets/images/arrows/filters-menu-closed.svg"
    (click)="onToggleClick()"
    class="collapsed-img"
    alt="collapse"
  />
</div>
